// src/layouts/dashboard/components/Projects.js
import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// API
import { dashboardApi } from "api/dashboardApi";

function Projects() {
  const [topHospitals, setTopHospitals] = useState([]);
  const [menu, setMenu] = useState(null);

  useEffect(() => {
    loadTopHospitals();
  }, []);

  const loadTopHospitals = async () => {
    try {
      const data = await dashboardApi.getDashboardData();
      if (data && data.topHospitals) {
        setTopHospitals(data.topHospitals);
      }
    } catch (err) {
      console.error("Failed to load top hospitals:", err);
    }
  };

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  // Calculate max claims for progress bar
  const maxClaims = Math.max(...topHospitals.map((h) => h.value), 0);

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={closeMenu}>View Details</MenuItem>
      <MenuItem onClick={closeMenu}>Export Report</MenuItem>
      <MenuItem onClick={closeMenu}>Refresh</MenuItem>
    </Menu>
  );

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Top Hospitals Performance
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{
                fontWeight: "bold",
                color: ({ palette: { info } }) => info.main,
                mt: -0.5,
              }}
            >
              assessment
            </Icon>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;<strong>Top 5</strong> hospitals by claims volume
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox color="text" px={2}>
          <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={openMenu}>
            more_vert
          </Icon>
        </MDBox>
        {renderMenu}
      </MDBox>
      <MDBox p={2}>
        {topHospitals.map((hospital, index) => (
          <MDBox key={index} mb={2}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <MDTypography variant="body2" fontWeight="medium">
                {hospital.label}
              </MDTypography>
              <MDTypography variant="body2" color="text">
                {hospital.value} claims{" "}
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                }).format(hospital.amount)}
              </MDTypography>
            </MDBox>
            <MDProgress
              variant="determinate"
              value={(hospital.value / maxClaims) * 100}
              color={index === 0 ? "info" : index === 1 ? "success" : "warning"}
            />
          </MDBox>
        ))}
      </MDBox>
    </Card>
  );
}

export default Projects;
